import React, { useState } from 'react';
import {
    getLocalStorageItem,
    getUserNotificationPreferenceApi,
    popup,
    updateUserNotificationPreferenceApi,
} from '../../../utils';
import {
    LOCAL_STORAGE,
    QUERY_KEYS,
    USER_NOTIFICATION_PREFERENCES_COLUMNS,
} from '../../../constants';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Table } from '../Table';
import { ConfirmationBox } from './ConfirmationBox';
import { isEmpty } from 'lodash';
import { getUpdatedNotificationTitle } from './constant';

const NotificationSettings = ({ id, disabled = false }) => {
    const userId = id || getLocalStorageItem(LOCAL_STORAGE.USER_ID);
    const queryClient = useQueryClient();
    const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
    const [nextValue, setNextValue] = useState(undefined);

    const { data, error, isFetching, isError } = useQuery({
        queryKey: [QUERY_KEYS.USER_NOTIFICATION_PREFERENCES, { userId }],
        queryFn: async () => await getUserNotificationPreferenceApi({ user_id: userId }),
        select: (data) => data.data.map((nt) => ({ ...getUpdatedNotificationTitle(nt), disabled })),
    });
    if (isError) popup('error', error.message);

    const onToggleHandler = (v) => {
        setOpenConfirmationBox(true);
        setNextValue(v);
    };

    const updateMutation = useMutation({
        mutationFn: async () =>
            updateUserNotificationPreferenceApi({
                user_id: userId,
                notification_type_id: nextValue.notification_type_id,
                enabled: nextValue.next_value,
            }),
        onSuccess: ({ message }) => {
            popup('success', message);
            setNextValue(undefined);
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.USER_NOTIFICATION_PREFERENCES, { userId }],
                exact: false,
            });
        },
        onError: (error) => popup('error', error.message),
    });

    const onConfirm = (v) => {
        if (v && !isEmpty(nextValue)) updateMutation.mutate();
    };

    return (
        <>
            <Table
                columns={USER_NOTIFICATION_PREFERENCES_COLUMNS}
                data={data}
                stickyColumns={['Notification Type']}
                isLoading={isFetching}
                hidePagination={true}
                pageName='Notification'
                tableStyle={{ height: 'auto', overflowY: 'hidden' }}
                debouncedApiCall={onToggleHandler}
            />
            {openConfirmationBox && (
                <ConfirmationBox
                    setConfirm={(v) => onConfirm(v)}
                    openConfirmationBox={openConfirmationBox}
                    setOpenConfirmationBox={setOpenConfirmationBox}
                    customMessage={`Are you sure you want to ${nextValue.next_value ? 'enable' : 'disable'} "${nextValue.notification_name}" email notifications?`}
                />
            )}
        </>
    );
};

export default NotificationSettings;
